<template>
	<div class="element-wrapper compact">
		<h6 class="element-header">
			{{ t.last_transaction }}
		</h6>
		<div class="element-box-tp">
			<table class="table table-clean" v-if="transactions">
				<tr v-for="row in transactions">
					<td>
						<div class="value">
							{{row.info}}
						</div>
						<span class="sub-value">
							<router-link :to="{name: 'userprofile', params: {id: row.user.id}}">
								@{{ row.user.username }}
							</router-link>
						</span>
					</td>
					<td class="text-right">
						<div class="value">
							<router-link :to="{name: 'transactions', params: {id: row.id}}">
							{{ row.type.operator }}{{ row.amount | toMoney(row.currency) }}
							</router-link>
						</div>
						<span class="sub-value">{{ dateTimeFormat(row.addedAt) }}</span>
					</td>
				</tr>
			</table>
			<div v-if="pagination">
				<router-link v-if="pagination.totalCount > 1" class="centered-load-more-link" :to="{name: 'transactions'}">
					<span>{{ t.load_more_transactions }}</span>
				</router-link>
			</div>

		</div>
	</div>
</template>

<script>
    export default {
        name: 'transactions',
        props: {
              filter: {
                  type: Object,
                  default: () => ( {
                      page: 1,
                    per_page: 10
                  })
              }
        },
        watch: {
            filter: {
                // the callback will be called immediately after the start of the observation
                immediate: true,
                handler (val, oldVal) {
                    // do your stuff
                    this.fetchTransactions()
                }
            }
        },
        data () {
            return {
                t: this.$root.t,
                transactions: null,
                isLoading: false,
                pagination: null
            }
        },
	    mounted () {
          this.fetchTransactions()
	    },
	    methods: {
            fetchTransactions () {

                if (!this.isLoading) {
                    this.isLoading = true;
                    this.$http.get(api+'api/v1/user/transactions?noCache=1', {params: this.filter }).then(response => {
                        // get body data
                    this.transactions = response.body.result.transactions;
                    this.pagination = response.body.result.pagination;
                    this.isLoading = false;
                    this.status = response.status;

                }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                        this.transactions = null;
                    })


                }
            },
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/widget/transaction.vue